defineDs('DanskeSpil/Domain/PlayTogether/Scripts/Templates/ViewCoupon/DrawsListItem',
  [
    'Shared/Framework/Mithril/Scripts/Core/Mithril',
    'DanskeSpil/Framework/NumberGames/Scripts/Helpers/Utils',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Loader',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/CtaButton',
    'DanskeSpil/Domain/PlayTogether/Scripts/Templates/Common/Modal',
    'DanskeSpil/Domain/NumberGames/Scripts/Models/ViewCouponModel',
    'DanskeSpil/Domain/NumberGames/Scripts/Components/Coupon'
  ],
  function (m, NumberGamesUtils, Loader, CtaButton, Modal, ViewCouponModel, Coupon) {
    var iconsPath = '/Components/DanskeSpil/Domain/PlayTogether/Graphics/SpriteSheets/PlayTogetherIcons.svg';

    var DrawsListItem = {
      controller: function ({ controller, drawItem }) {
        Object.assign(this, controller);
        this.drawItemDictionary = this.rootDictionary.get.bind({ prefix: 'ViewCoupon/DrawsSection/DrawItem/' });

        const couponId = drawItem.couponId;
        const couponArgs = {
          playModel: {
            ...this.play,
            groupName: this.clubName(),
          },
          gameType: this.gameType,
          fundingId: this.myFunding()?.fundingId,
          groupPlayId: this.play.groupPlayId,
          couponId: couponId
        };

        this.couponInfo = m.prop(null);
        this.loadingCouponInfo = m.prop(false);

        this.toggleShowDrawItem = () => {
          const drawIndex = drawItem.index;
          if (this.openedItem() === drawIndex) {
            this.openedItem(null);
            return;
          }
          this.openedItem(drawIndex);

          //  if draw has a couponId and the draw has passed and `couponInfo` is not set
          //  then we want to get the coupon information
          if (drawItem.couponId && drawItem.hasPassed && !this.couponInfo()) {
            const couponModel = ViewCouponModel.new({
              game: this.gameType,
              couponId: couponId,
              isPlayTogetherGame: true,
              fundingId: couponArgs.fundingId,
              groupPlayId: couponArgs.groupPlayId
            });
            this.loadingCouponInfo(true);
            couponModel.loadCoupon().then((coupon) => {
              this.loadingCouponInfo(false);
              this.couponInfo(coupon);
              m.redraw();
            });
          }
        };

        this.setBodyHeight = (itemIndex) => {
          return ($element) => {
            var $inner = $element.querySelector('.draw-item__body-inner');
            var targetHeight = this.openedItem() === itemIndex ? $inner.offsetHeight : 0;

            $element.style.maxHeight = targetHeight + 'px';
          };
        };

        const couponModal = new Modal();

        this.openCoupon = () => {
          const couponBody = m('div', m(Coupon, {
            controller: couponArgs,
          }));

          couponModal.setContent(couponBody);
          couponModal.show();
        };
      },
      view: function (controller, args) {
        var drawItem = args.drawItem;
        var isOpened = controller.openedItem() === drawItem.index;
        const drawDate = NumberGamesUtils.formatISO8601(drawItem.drawDate);

        var winningsContent = () => {
          var totalWinningsAmount = controller.couponInfo().totalWinAmount;
          var myStakePercentage = controller.couponInfo().groupPlay.playerSharePercentage;
          var myTotalWinnings = controller.couponInfo().groupPlay.playerPrizeTotalAmount;

          if (totalWinningsAmount === 0) {
            return m('div', controller.drawItemDictionary('NoWinningsDescription'));
          }
          return [
            m('.draw-item__details-row', [
              m('.details-label', controller.drawItemDictionary('CouponTotalWinningsLabel')),
              m('.draw-item__value', NumberGamesUtils.formatCurrency(totalWinningsAmount))
            ]),
            m('.draw-item__details-row.draw-item__details-row--totals', [
              m('strong.details-label', [
                controller.drawItemDictionary('YourWinningsLabel', { percentage: myStakePercentage })
              ]),
              m('.draw-item__value', m('strong', NumberGamesUtils.formatCurrency(myTotalWinnings)))
            ])
          ];
        };

        var drawItemBodyContent = () => {
          if (controller.play.mySummary.rowCount === 0) {
            return m('.draw-item__text', controller.drawItemDictionary('NotParticipatingDescription'));
          }

          var content = null;
          var ctaButtonOptions = {
            onClick: controller.openCoupon,
            options: ['small']
          };
          if (drawItem.couponId) {
            if (drawItem.hasPassed) {
              content = m('.draw-item__text',
                controller.loadingCouponInfo() || !controller.couponInfo() ?
                  Loader(controller) : winningsContent()
              );
            } else {
              content = m('.draw-item__text', controller.drawItemDictionary('DrawHasNotPassedDescription', { drawDate }));
            }
            ctaButtonOptions.text = controller.drawItemDictionary('ViewCouponButton');
          } else {
            content = m('.draw-item__text', controller.drawItemDictionary('TemporaryCouponDescription'));
            ctaButtonOptions.text = controller.drawItemDictionary('TemporaryCouponButton');
          }
          return [
            content,
            CtaButton(ctaButtonOptions)
          ];
        };

        // View:
        return m('.draw-item', {
          class: isOpened ? 'draw-item--opened' : ''
        }, [
          m('.draw-item__header', {
            onclick: controller.toggleShowDrawItem
          }, [
            m('.draw-item__left', controller.drawItemDictionary('ItemLabel', { index: drawItem.index })),
            m('.draw-item__right', [
              drawDate,
              m('svg.icon', [
                m('use', { href: iconsPath + '#arrow' })
              ])
            ])
          ]),
          // draw item body
          m('.draw-item__body', {
            config: controller.setBodyHeight(drawItem.index, this)
          }, m('.draw-item__body-inner', drawItemBodyContent()))
        ]);
      }
    };

    // Public functions:
    return DrawsListItem;
  });
